export const appShellTag = 'inav-app-shell';
export const backLinkTag = 'inav-back-link';
export const multiselectComboboxTag = 'inav-multiselect-combobox';
export const errorSummaryTag = 'inav-error-summary';
export const medicalDeviceInformationPageTag = 'inav-medical-device-information-page';
export const triageOutcomeTag = 'inav-triage-outcome';
export const nhsFooterTag = 'inav-nhs-footer';
export const nhsHeaderTag = 'inav-nhs-header';
export const accessDeniedPageTag = 'inav-access-denied-page';
export const journeyStartPageTag = 'inav-journey-start-page';
export const serviceIntroductionPageTag = 'inav-service-introduction-page';
export const triageBooleanQuestionTag = 'inav-triage-boolean-question';
export const triageChoiceQuestionTag = 'inav-triage-choice-question';
export const triageSearchQuestionTag = 'inav-triage-search-question';
export const triageGroupQuestionTag = 'inav-triage-group-question';
export const triageImageUploadQuestionTag = 'inav-triage-image-upload-question';
export const triageNumberQuestionTag = 'inav-triage-number-question';
export const triageTextQuestionTag = 'inav-triage-text-question';
export const sessionExpiredPageTag = 'inav-session-expired-page';
export const termsOfServicePageTag = 'inav-terms-of-service-page';
export const serviceUnavailableTag = 'inav-service-unavailable';

export type InavElementTag =
  | typeof appShellTag
  | typeof backLinkTag
  | typeof multiselectComboboxTag
  | typeof errorSummaryTag
  | typeof medicalDeviceInformationPageTag
  | typeof triageOutcomeTag
  | typeof nhsFooterTag
  | typeof nhsHeaderTag
  | typeof accessDeniedPageTag
  | typeof journeyStartPageTag
  | typeof serviceIntroductionPageTag
  | typeof triageBooleanQuestionTag
  | typeof triageChoiceQuestionTag
  | typeof triageSearchQuestionTag
  | typeof triageGroupQuestionTag
  | typeof triageImageUploadQuestionTag
  | typeof triageNumberQuestionTag
  | typeof triageTextQuestionTag
  | typeof sessionExpiredPageTag
  | typeof termsOfServicePageTag
  | typeof serviceUnavailableTag;